export default {
  title: 'How do you like {{name}}?',
  description: 'Your feedback is anonymous and helps us improve.',
  upload_google_review: {
    title: 'Review us & get rewarded',
  },
};
